import Layout from 'layout';
import { ExtendGridBox } from 'styles/integrations';
import SideBar from 'components/marketplace/sideBar';
import Content from 'components/marketplace/content';
import Banner from 'components/marketplace/banner';
import { frontmatter } from 'data/marketplace/integrations';
import arrow from 'img/ui/arrow_black.svg';
import OwnAppSection from 'components/marketplace/ownAppSection';

const MostPopular = () => {
  const [mostPopularCard] = frontmatter.items.filter((item) => item.title === 'Intercom');
  return (
    <Layout
      metaTitle="Most popular | Integrations"
      canonical="/integrations/most-popular/"
      metaDescription="See trending LiveSession integrations. Our users love using these!"
    >
      <div className="container">
        <ExtendGridBox>
          <div className="breadcrumbs">
            <p>
              <a href="/integrations/">Integrations</a>
            </p>
            <img src={arrow} alt="arrow" title="Arrow" />
            <p>
              <a href="/integrations/most-popular/">
                <strong>Most popular</strong>
              </a>
            </p>
          </div>
          <SideBar activeCategory="Most popular" />
          <Content activeCategory="Most popular" hideTitle>
            <Banner
              activeCategory="Most popular"
              card={mostPopularCard}
              text="See trending LiveSession integrations. Our users love using these!"
            />
          </Content>
        </ExtendGridBox>
        <OwnAppSection />
      </div>
    </Layout>
  );
};

export default MostPopular;
